module.exports = __webpack_public_path__ + "img/waze.ebd9fc2d.svg";